import React, { useMemo } from 'react';
import { HelpButton } from 'components/common/census/HelpButton';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import CensusUploadPageStore, {
  QuoteChecklistCensusUploadPageStoreContext,
  useQuoteChecklistCensusUploadPageStore,
} from 'store/pages/quote/add-employees/census/pageStore';
import { BasicCensusFlowLayout } from 'components/common/census/BasicCensusFlowLayout';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { RouteV2Id } from 'routes/routesConfigV2';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = () => {
  const pageStore = useQuoteChecklistCensusUploadPageStore();
  return <BasicCensusFlowLayout pageStore={pageStore} />;
};

const CensusUploadPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new CensusUploadPageStore({ groupId, enrollmentPeriodId: periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <QuoteChecklistCensusUploadPageStoreContext.Provider value={pageStore}>
      <PageInFlowNoSidebarLayout
        contentWidth="standard"
        domainParams={{ groupId, periodId, cartId }}
        pageId={RouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_UPLOAD}
        pageHeader={{ subtitle: <HelpButton /> }}
      >
        <PageContent />
      </PageInFlowNoSidebarLayout>
    </QuoteChecklistCensusUploadPageStoreContext.Provider>
  );
};

export default CensusUploadPage;
